import React, { Component } from 'react';
import { FormControlLabel, Switch } from '@mui/material';

class BreadCrumb extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div className="breadcrumb-bar">
                <div className="container-fluid">
                    <div className="row align-items-center">
                        <div className="col-md-12 col-12">
                            <nav aria-label="breadcrumb" className="page-breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item active" aria-current="page">
                                        Quality Control
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        QC Samples
                                    </li>
                                </ol>
                            </nav>
                            <div style={{ display: 'flex' }}>
                                <h2 className="breadcrumb-title">QC Samples</h2>
                                <FormControlLabel
                                    value="showArchived"
                                    control={
                                        <Switch
                                            checked={this.props.showArchived}
                                            onChange={this.props.handleArchiveToggle}
                                        />
                                    }
                                    label={this.props.showArchived ? 'Hide Archives' : 'Show Archives'}
                                    labelPlacement="end"
                                    className="m-0 breadcrumb-control"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default BreadCrumb;
